export default { 
  professional_profile: {}  
}